import i18n from '@/i18n'
import Index from './index.vue'
import layout from '../layout.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const pathPrefix = '/v-admin/company-admin/custom-landing-page'

const customLandingPageRoute = {
  path: `${pathPrefix}`,
  component: layout,
  meta: {
    permission: ['PERM_EDIT_MOBILE_LANDING_PAGE', 'PREMIUM_CUSTOM_MOBILE_LANDING_PAGE'],
    titleI18nKey: 'admin.company.customMobileLandingPage.menu',
    menu: {
      labelI18nKey: i18n.t('admin.company.customMobileLandingPage.menu'),
      get label () {
        return i18n.t('admin.company.customMobileLandingPage.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
    },
    isAllInclude: true,
    isNewPage: true,
    isRootBreadcrumb: true,
    breadcrumb: { hidden: true }
  },
  children: [
    {
      path: '',
      component: Index,
      meta: {
        titleI18nKey: 'admin.company.customMobileLandingPage.menu'
      }
    }
  ]
}

export default customLandingPageRoute
